import { render, staticRenderFns } from "./ActivityCard.vue?vue&type=template&id=2292422c&scoped=true"
import script from "./ActivityCard.vue?vue&type=script&lang=js"
export * from "./ActivityCard.vue?vue&type=script&lang=js"
import style0 from "./ActivityCard.vue?vue&type=style&index=0&id=2292422c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2292422c",
  null
  
)

export default component.exports